export default __webpack_public_path__ + "static/media/slider6.fdb54377.jpg";